export default "__VITE_ASSET__70022aa1__"